<template>
    <div id="contact">
        <ContactView></ContactView>
    </div>
    <div class="home" id="home">
        <div class="row">
            <div class="col-12 align-items-center d-flex home-div">
                <div class="row">
                    <h2 class="heading">
                        About Us
                    </h2>
                    <h5 class="description">
                        At SoWell Prepared, we’re not just a tax preparation service, we’re a family, and we’re
                        proud to share our story with you. As a Black-owned, family-operated business, our
                        roots run deep, and our commitment to our community runs even deeper. Founded by
                        Calvin and Antinita Coates, SoWell Prepared is a living tribute to Antinita’s father, Henry
                        Lee Sowell, whose commitment to always being prepared and determined spirit inspire
                        us everyday. <br><br>
                        Our journey began four years ago, starting with a simple desire to understand our own
                        taxes. We never expected that this personal endeavor would grow into a passion, and
                        that passion would evolve into something much greater than ourselves. As we began
                        helping family members and friends, we found more than a business opportunity—we
                        found our purpose. Each tax return became a chance to make a difference, to offer
                        reassurance, and to build trust. It’s the stories behind each client that matter to us—the
                        challenges you’ve faced, the goals you’re striving for, and the dreams you’re working to
                        achieve. <br><br>
                        At SoWell Prepared, our mission goes far beyond numbers on a form. We’re here to
                        empower you, to walk beside you on your financial journey, and to make sure you
                        always feel informed and confident. We don’t just file your taxes; we educate, we
                        advocate, and we care. We take pride in breaking down the complexities of tax law into
                        conversations that make sense, helping you understand how to maximize your
                        deductions and credits while planning for a brighter financial future.<br><br>
                    </h5>
                </div>
            </div>
            <div class="col-12 align-items-center d-flex home-div">
                <div class="row">
                    <div class="col-lg-6 col-12">
                        <h5 class="description">
                            As a Black-owned business, we carry a deep sense of responsibility to foster financial
                            literacy and empowerment within our community. We believe that every step towards
                            financial understanding is a step towards freedom, and we’re here to guide you with the
                            same care and dedication that we would offer our own family. Our clients are more than
                            customers—they are our partners, and we are honored to be part of their journey. <br><br>
                            Thank you for choosing SoWell Prepared. We’re not just here to provide a service;
                            we’re here to share in your story, to help you navigate life’s financial paths, and to
                            celebrate every milestone along the way. Together, let’s make each step a step forward.
                        </h5>
                    </div>
                    <div class="col-lg-6 col-12 d-flex-justify-content-center">
                        <img src="about-us.jpg" class="home-img" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ContactView from '@/views/ContactView.vue'

export default {
    name: 'HomeView',
    components: {
        ContactView
    }
}
</script>

<style>
.home {
    padding: 25px 0;
    background-color: rgba(0, 0, 0, 0.15);
}

#contact {
    background-color: rgba(0, 0, 0, 0.25);
}

.home-div {
    padding: 0% 7.5%;
    padding-left: 7.5%
}

.home-img {
    width: 100%;
    border-radius: 10px;
}

.heading {
    color: #ffffff;
    font-weight: bold;
    text-align: left;
    margin: 1rem 0;
    text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);
    letter-spacing: 1px;
    padding-top: 1rem;
}

.description {
    color: #e6e3e3;
    line-height: 1.6;
    text-align: left;
    letter-spacing: 0.5px;
    font-size: 1.35rem;
}

@media(max-width: 1400px) and (min-width: 1200px) {
    .description {
        font-size: 1.4rem;
    }
}

@media(max-width: 1200px) and (min-width: 992px) {
    .description {
        font-size: 1.4rem;
    }
}

@media(max-width: 992px) and (min-width: 768px) {
    .heading {
        font-size: 1.6rem
    }

    .description {
        font-size: 1.3rem;
    }

    .home-img {
        width: 60%;
        border-radius: 10px;
        margin: 0 20%
    }
}

@media(max-width: 768px) and (min-width: 576px) {
    .heading {
        font-size: 1.4rem
    }

    .description {
        font-size: 1.2rem;
    }

    .home-img {
        width: 60%;
        border-radius: 10px;
        margin: 0 20%
    }
}

@media(max-width: 576px) and (min-width: 420px) {
    .heading {
        font-size: 1.3rem
    }

    .description {
        font-size: 1.15rem;
    }

    .home-img {
        width: 90%;
        border-radius: 10px;
        margin: 0 5%
    }

    .home {
        padding: 0rem 0;
        padding-bottom: 1.65rem;
    }
}

@media(max-width: 420px) and (min-width: 360px) {
    .heading {
        font-size: 1.2rem
    }

    .description {
        font-size: 1.1rem;
    }

    .home-img {
        width: 95%;
        border-radius: 7.5px;
        margin: 0 2.5%
    }

    .home {
        padding: 0rem 0;
        padding-bottom: 1.5rem;
    }
}

@media(max-width: 360px) {
    .heading {
        font-size: 1.05rem
    }

    .description {
        font-size: 0.95rem;
    }

    .home-img {
        width: 100%;
        border-radius: 7.5px;
        margin: 0
    }

    .home {
        padding: 0rem 0;
        padding-bottom: 1.5rem;
    }
}
</style>